<template>
  <div>
    <!-- 菜单切换tabs -->
    <activity-tabs></activity-tabs>
    <el-row :gutter="10" class="disposition">
      <el-col :span="9">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>表单配置</span>
          </div>
          <div class="text item">
            <el-form
              :model="ruleDataForm"
              ref="ruleDataForm"
              :inline="true"
              label-width="108px"
            >
              <el-table
                :data="ruleDataForm.tableData"
                style="width: 100%"
                border
                class="tableData"
              >
                <el-table-column
                  prop="FieldDesc"
                  label="表单项"
                  align="center"
                ></el-table-column>

                <el-table-column align="center" label="是否显示">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'tableData.' + scope.$index + '.IsShow'"
                    >
                      <el-checkbox v-model="scope.row.IsShow"></el-checkbox>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="是否必填">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'tableData.' + scope.$index + '.IsRequired'"
                    >
                      <el-checkbox v-model="scope.row.IsRequired"></el-checkbox>
                    </el-form-item>
                  </template>
                </el-table-column>
              </el-table>
              <br />
              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitFormData('ruleDataForm')"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
      <el-col :span="15">
        <el-row :gutter="10">
          <el-col :span="13">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>表单链接</span>
              </div>
              <div class="code" style="display: none">
                <vue-qr
                  ref="qrCode"
                  :text="this.activityLinks.FormLink"
                  :logoScale="40"
                  :size="190"
                  :margin="10"
                />
              </div>

              <div class="text item links">
                请点击
                <el-button
                  @click="copyFormCode($event)"
                  type="text"
                  size="small"
                  >复制链接</el-button
                ><el-button @click="downloadQR" type="text" size="small"
                  >下载二维码</el-button
                >
              </div>
            </el-card>
          </el-col>
          <el-col :span="11">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>签到入口链接</span>
              </div>
              <div class="text item links">
                请点击
                <el-button
                  @click="copySignLinkCode($event)"
                  type="text"
                  size="small"
                  >复制链接</el-button
                >
              </div>
            </el-card>
          </el-col>
        </el-row>
        <br />
        <el-row :gutter="10">
          <el-col :span="13">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>设置默认活动 / 活动报名截止时间</span>
              </div>
              <div class="text item">
                <el-form
                  :model="ruleFormDefault"
                  ref="ruleFormDefault"
                  label-width="100px"
                >
                  <el-form-item prop="IsDefault" label="是否默认活动">
                    <el-switch v-model="ruleFormDefault.IsDefault"></el-switch>
                  </el-form-item>
                  <el-form-item prop="BgImg" label="默认图片">
                    <template v-if="ruleFormDefault.BgImg">
                      <img
                        :src="
                          ruleFormDefault.BgImg +
                          '?x-oss-process=image/resize,h_1500,w_930,m_fixed'
                        "
                        class="backImg"
                      />
                    </template>
                    <div class="editor-custom-btn-container">
                      <UploadPan
                        ref="upload"
                        v-model="fileList"
                        :form="form"
                        class="editor-upload-btn"
                        :model="model"
                        @on-close="handleCloseUpload"
                        @on-update="handleOnUpdate"
                        :accept="accept"
                        color="#1890ff"
                      />
                      <span style="font-size: 12px"
                        >宽1500（像素）*高930（像素）</span
                      >
                    </div>
                  </el-form-item>
                  <el-form-item prop="ApplyAwardDeadline" label="报名截止时间">
                    <el-date-picker
                      v-model="ruleFormDefault.ApplyAwardDeadline"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm"
                      placeholder="选择报名截止时间"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      type="primary"
                      @click="submitFormDefault('ruleFormDefault')"
                      >提交</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
            </el-card>
          </el-col>
          <el-col :span="11">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>活动推广链接</span>
              </div>
              <div class="text item">
                <el-form :model="ruleFormLink" ref="ruleFormLink">
                  <el-form-item
                    prop="EA_ThirdLink"
                    :rules="{
                      required: true,
                      message: '请输入活动推广链接',
                      trigger: 'blur',
                    }"
                  >
                    <el-input
                      v-model="ruleFormLink.EA_ThirdLink"
                      placeholder="推广链接，如：https://chcf.hroot.com"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      type="primary"
                      @click="submitFormLink('ruleFormLink')"
                      >提交</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  getActivityLinks,
  UpdPromotionalLink,
  getfieldConfig,
  UpdFieldConfig,
  getActivityDefaultInfo,
  ActivitySetDefault,
} from '../../api/api'
import UploadPan from '../../components/Upload'
import store from '@/store'
import VueQr from 'vue-qr'
import clip from '../../../util/clipboard'
import ActivityTabs from '@/components/ActivityTabs.vue'
export default {
  data() {
    return {
      //表单配置
      ruleDataForm: {
        tableData: [],
      },
      // 活动推广链接
      ruleFormLink: {
        ActivityIDStr: store.getters.getCurActivityId,
        EA_ThirdLink: '',
      },
      // 活动链接
      activityLinks: {
        PromotionalLink: '',
        FormLink: '',
        SignLink: '',
      },
      // 设置默认活动、活动报名截止时间
      ruleFormDefault: {
        ActivityIDStr: '',
        BgImg: '',
        ApplyAwardDeadline: '',
        IsDefault: false,
      },
      curActivityId: store.getters.getCurActivityId, // 活动 ID
      fileList: [],
      model: `hrmarket/${new Date().getFullYear()}${new Date().getMonth() + 1}`,
      form: {
        bucket: 'video-hroot',
        region: 'oss-cn-hangzhou',
      },
      accept: '.jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PBG,.GIF',
    }
  },
  methods: {
    handleQuery() {
      // 获取链接
      getActivityLinks(this.curActivityId).then((res) => {
        if (res.data.success) {
          this.activityLinks = res.data.response
          this.ruleFormLink.EA_ThirdLink = this.activityLinks.PromotionalLink
        }
      })
      // 获取表单配置项
      getfieldConfig(this.curActivityId).then((res) => {
        if (res.data.success) {
          this.ruleDataForm.tableData = res.data.response
        }
      })
      // 获取默认活动信息
      getActivityDefaultInfo(this.curActivityId).then((res) => {
        console.log('res------', res)
        if (res.data.success) {
          this.ruleFormDefault = res.data.response
          this.ruleFormDefault.ActivityIDStr = this.curActivityId
        }
      })
    },

    // 表单配置项提交
    submitFormData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          UpdFieldConfig({
            activityId: this.curActivityId,
            configs: { FieldConfigList: this.ruleDataForm.tableData },
          }).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: 'success',
              })
              this.handleQuery()
            } else {
              this.$message({
                message: '操作失败！',
                type: 'error',
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 设置默认活动 / 活动报名截止时间
    submitFormDefault(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          ActivitySetDefault(this.ruleFormDefault).then((res) => {
            console.log('res-----', res)
            if (res.data.success) {
              this.$message({
                message: res.data.response,
                type: 'success',
              })
              this.handleQuery()
            } else {
              this.$message({
                message: '操作失败！',
                type: 'error',
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 推广链接按钮
    submitFormLink(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          UpdPromotionalLink(this.ruleFormLink).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.response,
                type: 'success',
              })
              this.handleQuery()
            } else {
              this.$message({
                message: '操作失败！',
                type: 'error',
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    downloadQR() {
      const a = document.createElement('a') // 下载的文件名
      a.download = '二维码' // url
      a.href = this.$refs.qrCode.$el.src // 触发点击
      a.click()
    },
    // 复制 表单链接
    copyFormCode(event) {
      clip(this.activityLinks.FormLink, event)
    },
    // 复制 签到入口链接
    copySignLinkCode(event) {
      clip(this.activityLinks.SignLink, event)
    },

    handleCloseUpload() {
      this.fileList = []
    },
    // ?x-oss-process=image/resize,h_1500,w_930,m_fixed
    handleOnUpdate(obj) {
      const url = `https://${this.form.bucket}.${this.form.region}.aliyuncs.com/${obj.OssKey}`
      this.ruleFormDefault.BgImg = url
    },
  },
  components: {
    ActivityTabs,
    VueQr,
    UploadPan,
  },
  mounted() {
    this.handleQuery()
  },
}
</script>

<style lang="scss">
.links .el-button--text span {
  font-size: 14px !important;
}
.disposition {
  margin-bottom: 20px;
  .box-card {
    width: 95%;
    .clearfix {
      span {
        font-size: 16px;
      }
    }
    .links .el-button--text {
      border-bottom: 1px solid #409eff;
      padding-bottom: 5px;
    }
  }
  .tableData .el-form-item {
    margin-bottom: 0;
  }
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}
img.backImg {
  width: 100%;
  height: auto;
}
</style>
